import { ExternalLink } from "lucide-react";
import { Link } from "wouter";

type Props = {
  path?: string | null;
  status?: "direct" | "restored" | "unavailable" | "held" | "retired";
  survivorId?: number | null;
  testId?: string;
};

/** Only consumes the verified server destination; never synthesizes collection IDs. */
export function PublicHostProfileLink({ path, status, survivorId, testId }: Props) {
  if (path && (status === "direct" || status === "restored" || !status)) {
    return <a
      href={`${(import.meta.env.BASE_URL || "/").replace(/\/$/, "")}${path}`}
      target="_blank"
      rel="noopener"
      className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-1.5 text-xs font-medium hover:bg-muted/40 transition-colors"
      aria-label="View live profile"
      data-testid={testId}
    >
      <ExternalLink className="h-3.5 w-3.5" /> View live profile
    </a>;
  }
  if (status === "retired" && survivorId) {
    return <Link href={`/admin/users?id=${survivorId}`} className="text-xs underline">
      Historical merged account — view survivor #{survivorId}
    </Link>;
  }
  return <span className="text-xs text-muted-foreground">{
    status === "held" ? "Public profile link needs review" :
    status === "retired" ? "Historical merged account" : "Public profile unavailable"
  }</span>;
}
